import PartyCharacter from "../character/PartyCharacter";

export default class CharacterSave {
    constructor() {        
    }

    /**
     * @param {PartyCharacter} character
     * @returns {Object}
     */
    static generateSave(character) {
        const saveState = {};

        /////////////////////////////////////////////////
        // Position
        /////////////////////////////////////////////////

        saveState.position = {
            x: character.position.worldCoordinateOrigin.x,
            y: character.position.worldCoordinateOrigin.y
        };

        saveState.facingLeft = character.position.facingLeft;

        if (character.skillId) {
            saveState.skillId = character.skillId;
        }

        return saveState;
    }

    /**
     * @param {PartyCharacter} character
     * @param {Object} saveState 
     */
    static loadSave(character, saveState) {
        if (!saveState) {
            return;
        }

        /////////////////////////////////////////////////
        // Position
        /////////////////////////////////////////////////

        character.position.setWorldCoordinateOriginXY(saveState.position.x, saveState.position.y);

        character.position.facingLeft = saveState.facingLeft;

        if (saveState.skillId) {
            character.skillId = saveState.skillId;
        }
    }
}